module.exports = __webpack_public_path__ + "static/media/home-hero--bg-armenia.1e77c87c.jpg";